import { Actor, type HttpAgent } from '@dfinity/agent';
import { idlFactory, type _SERVICE } from '../declarations/icspicy/icspicy.did';

import { getCanisterId } from '../config/canisterIds';

const getICSpicyCanisterId = (): string => {
  // Try environment variable first
  const envId = import.meta.env.VITE_ICSPICY_CANISTER_ID;
  if (envId && typeof envId === 'string' && envId.length > 0) {
    return envId;
  }
  // Fallback to config
  const id = getCanisterId('icspicy');
  if (!id || id.length === 0) {
    // Don't throw error, return empty string and let the caller handle it
    console.warn('ICSpicy canister ID not configured. Set VITE_ICSPICY_CANISTER_ID in .env.production');
    return '';
  }
  return id;
};

export async function createICSpicyActor(agent: HttpAgent): Promise<_SERVICE> {
  const canisterId = getICSpicyCanisterId();
  if (!canisterId || canisterId.length === 0) {
    throw new Error('ICSpicy canister ID not configured. Set VITE_ICSPICY_CANISTER_ID in .env.production');
  }
  return Actor.createActor(idlFactory, {
    agent,
    canisterId,
  });
}

